

const TYPE_ALIASES = {
  mcq: "mcq",
  mcqs: "mcq",
  "short-answer": "short-answer",
  "short answer": "short-answer",
  "true-false": "true-false",
  "true / false": "true-false",
  matching: "matching",
  "fill-blanks": "fill-blanks",
  "fill in blanks": "fill-blanks"
};

export function normalizeQuestionType(value) {
  if (!value) {
    return "mcq";
  }

  const key = value.trim().toLowerCase();
  return TYPE_ALIASES[key] ?? "mcq";
}

export function questionTypeLabel(type) {
  switch (type) {
    case "mcq":
      return "MCQ";
    case "short-answer":
      return "Short Answer";
    case "true-false":
      return "True / False";
    case "matching":
      return "Matching";
    case "fill-blanks":
      return "Fill in Blanks";
    default:
      return "Question";
  }
}